import { render, staticRenderFns } from "./NotificationPill.vue?vue&type=template&id=7b2e7e1b"
import script from "./NotificationPill.vue?vue&type=script&lang=js"
export * from "./NotificationPill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports